import { FC } from 'react';

import ModalSettings from '../../ModalSettings';
import { listKeysGroupingsVisit, ads_keys as ADS_KEYS } from '../../modal-settings/index';
import { prepareGroupsData } from '../../../../../../helpers/utils/reports';
import { groupingsData } from '../../../../constants/reportsVisits';
import { useActions } from '../../../../hooks/useActions';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';

// Создаём глубокую копию данных перед обработкой
const unsortedGroupings = prepareGroupsData(JSON.parse(JSON.stringify(groupingsData)));

// Экспорты для обратной совместимости
export const listKeysGroupings = listKeysGroupingsVisit;
export const ads_keys = ADS_KEYS;

interface GroupingsProps {
    isDisable?: boolean;
    hidePersonalDataGroups?: boolean;
}

const Groupings: FC<GroupingsProps> = ({ isDisable, hidePersonalDataGroups }) => {

    const { groupings } = useTypedSelector((state) => state.table);
    const { setGroupings, setMetaTableFetching, setMetaChartFetching, setMetaCompareChartFetching, setMetaCompareTableFetching } = useActions();

    const actionSet = (selected: any) => {

        setGroupings({ data: selected });

        setTimeout(() => {
            setMetaTableFetching({ value: true });
            setMetaChartFetching({ value: true });
            setMetaCompareChartFetching({ value: true });
            setMetaCompareTableFetching({ value: true });
        }, 50);
    };
    
    return (
        <ModalSettings
            hidePersonalDataGroups={hidePersonalDataGroups}
            title="Группировки"
            dataItems={unsortedGroupings}
            listKeys={listKeysGroupings}
            defSelected={groupings}
            defChecked={groupings.map((item) => item.key)}
            isDisable={isDisable}
            actionSet={actionSet}
            simplified={true}
            enableCustomMetrics={false}
            modalWidth={800}
        />
    );
};

export default Groupings;
